/*
 * Finish-orders.ts
 * Description: Includes the declaration
 * of finish order function
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing required global variables
import {APIURL} from '@/ts/variables';

// Creating an Order interface
interface Order {
    gift: string;
    notes: string;
    total_price: number;
    user_address: string;
    name: string;
    phone: string;
    town_ekatte: string;
    address: string;
}

/**
 * Updating an order
 *
 * @return {Object} Promise - submitted order
 * @param {Order} data - order data
 * @param {String} slug - id of a restaurant
 */
export function finishOrder(data: Order, slug: string) {
    // Getting data from local storage
    const jwt = localStorage.getItem('jwt');
    // Removing empty fields
    if (data.user_address === '') { delete data.user_address; }
    if (data.name === '') { delete data.name; }
    if (data.phone === '') { delete data.phone; }
    if (data.town_ekatte === '') { delete data.town_ekatte; }
    if (data.address === '') { delete data.address; }
    // Returning promise with the request
    return new Promise ((resolve, reject) => {
        Axios({
            url: APIURL + 'orders',
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {
                guest_id: localStorage.getItem(slug),
                payment_method: 'CASH_ON_DELIVERY',
                deliver_asap: true,
                ...data,
            },
        }).then(() => {
            resolve();
        }).catch((err) => {
            reject(err);
        });
    });
}
